import React, { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { Label, TextWithArrowButtonRoot } from './styled';
import { TextWithArrowButtonProps } from './types';

export const TextWithArrowButton: FC<React.PropsWithChildren<TextWithArrowButtonProps>> = ({
  onPress,
  messageId,
  withBorder = false,
}) => {
  const { formatMessage } = useIntl();

  return (
    <TextWithArrowButtonRoot
      href="#"
      onPress={event => {
        event?.preventDefault();
        onPress?.();
      }}
      withBorder={withBorder}
      accessibilityRole="link"
    >
      <Label variant="headerFour" accessibilityRole="header" accessibilityLevel={5}>
        {formatMessage({ id: messageId })}
      </Label>
      <Icon variant="next" height="$3.5" width="$4" color="dark.200" />
    </TextWithArrowButtonRoot>
  );
};
